
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import BusinessProfile from "@/components/BusinessProfileView/BusinessProfileView.vue"
import CustomerProfileView from "@/components/CustomerProfileView/CustomerProfileView.vue"
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';
import { get_token, get_user_details } from "@/router";
import Swal from "sweetalert2";


export default {
  components: {
    HomeNavBar,
    BusinessProfile,
    CustomerProfileView,
    InactivityModal
  },

  mounted() {
    this.user_details = get_user_details();
    this.token_exists = get_token();
    this.apply_profile_route();

    this.fetch_question_section();
    this.filter_membership_payment_history();
    this.fetch_type_of_organization();
    this.fetch_type_of_profile();
    this.fetchProfiles();

  },
  data() {
    return ({
      first_name: '',
      last_name: '',
      email: '',
      date_of_birth: '',
      phone_number: '',
      cv: null,
      cv_url: null,
      skills: [],
      work_experiences: [],
      educations: [],
      fileType: '',
      isLocalFile: false,
      local_file_url: null,
      street_address: '',
      town: '',
      postal_code: '',
      provinces: [],
      province_id: '',
      province_name: '',
      rating: 0,
      totalRatings: 0,
      user_details: {
        "user_role": '',

      },
      token_exists: true,
      isLoading: false,
      profile: {},
      errors: {},
      showPreview: false,
      file_name: '',
      user_id: '',
      newSkill: '',
      sections: [],
      isOpen: false,
      membership_payment_history: [],
      userHasPaid: false,

      company_name: '',
      type_of_organization: '',
      description: '',
      tell_number: '',
      location: '',
      organizationTypes: [],
      selected_type_of_organization: '',
      type_of_profile: [],
      selectedProfile: null,
      base_profiles: [],
      currentProfile: false,
      displayLetter: '',
      displayName: '',
      isBusinessProfile: false,
      isPersonalProfile: false,
      profileLoaded: false,
      profile_questions: [],
      base_profile_id: null,
      active_profile: null,
      active_user_profile: {},
      questions: [],
      selectedLocation: ''
    });
  },
  watch: {
    '$route.query': {
      handler() {
        this.apply_profile_route();
      }
    }
  },
  methods: {
    apply_profile_route() {
      this.user_id = this.$route.query.user_id;
      this.base_profile_id = this.$route.query.base;
      this.profileLoaded = false;
      this.currentProfile = false;

      if (!this.user_id && !this.base_profile_id && sessionStorage.getItem('profile_target_user_id')) {
        this.user_id = sessionStorage.getItem('profile_target_user_id');
      }

      if (this.base_profile_id) {
        this.isBusinessProfile = true;
        this.isPersonalProfile = false;
        this.profileLoaded = true;
        this.currentProfile = true;
      }
      else if (this.user_id) {
        this.isPersonalProfile = true;
        this.isBusinessProfile = false;
        this.profileLoaded = true;
        this.currentProfile = true;
      }
      else {
        this.getActiveProfile();
      }
    },

    onLocationSelected(location) {
      this.selectedLocation = location;
    },
    on_cart_updated() {

      // Forward the update to HomeNavBar component

      if (this.$refs.homeNavBarRef.$refs.cartRef) {
        this.$refs.homeNavBarRef.$refs.cartRef.load_cart();

      }

    },
    onProfileUpdated() {
      if (this.$refs.businessProfileRef?.fetchCompanyProfile) {
        this.$refs.businessProfileRef.fetchCompanyProfile();
      }
      this.$refs.homeNavBarRef.fetchProfiles();
    },
    get_created_business() {

      if (this.$refs.customerProfileRef?.fetchProfiles) {
        this.$refs.customerProfileRef.fetchProfiles();
      }
    },
    on_edit_buainess_profile(companyData) {
      this.$refs.homeNavBarRef.open_edit_profile(companyData);
    },
    filter_membership_payment_history() {
      this.token_exists = get_token();

      if (!this.user_id) {

        this.user_id = this.user_details.user_id;
      }

      const payload = {
        filter_values: {
          user_id: this.user_id,

        }
      }

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_user_membership_payment_history/`,
        method: "POST",
        data: JSON.stringify(payload),
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : { "Content-Type": "application/json" },
        success: (response) => {
          this.membership_payment_history = response.data.payment_history;

          this.userHasPaid = this.membership_payment_history.some(
            (payment) => payment.payment_status?.status === "paid"
          );

        },
        complete: () => {
          this.isLoading = false;
        },
      })
    },
    toggleSection() {
      this.isOpen = !this.isOpen;
      const sectionBody = this.$refs.sectionBody;
      if (this.isOpen) {
        $(sectionBody).slideDown(200);
      } else {
        $(sectionBody).slideUp(200);
      }
    },
    getToken() {
      return get_token();
    },
    toggleSidebar() {
      this.$refs.sidebar.$el.classList.toggle('close');
    },


    handleFileUpload(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
        const file = files[0];
        if (this.validateFile(file)) {
          this.cv = file;
          this.file_name = file.name;
          this.fileType = file.type;
          this.local_file_url = URL.createObjectURL(file);
          this.isLocalFile = true;
          this.showPreview = true;
          this.errorMessage = '';  // Clear error message
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Invalid File Type',
            text: 'Only PDF and Word documents are allowed.',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
          this.resetFileUpload();
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: 'No File Selected',
          text: 'Please select a file to upload.',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
        this.resetFileUpload();
      }
    },
    validateFile(file) {
      const allowedTypes = ['application/pdf', 'application/msword'];

      if (allowedTypes.includes(file.type)) {
        return true;
      } else {
        return false;
      }
    },
    validationProfileForm() {
      this.errors = {};
      let valid = true;

      if (this.first_name === '') {
        this.errors.first_name = 'First name is required';
        valid = false;
      }

      if (this.last_name === '') {
        this.errors.last_name = 'Last name is required';
        valid = false;
      }

      if (this.date_of_birth === '') {
        this.errors.date_of_birth = 'Date of birth is required';
        valid = false;
      }
      if (this.race_id === '') {
        this.errors.race_id = 'Race is required';
        valid = false;
      }
      if (this.gender_id === '') {
        this.errors.gender_id = 'Gender is required';
        valid = false;
      }
      if (this.title_id === '') {
        this.errors.title_id = 'Title is required';
        valid = false;
      }
      if (this.street_address === '') {
        this.errors.street_address = 'Street address is required';
        valid = false;
      }
      if (this.town === '') {
        this.errors.town = 'Town is required';
        valid = false;
      }
      if (this.postal_code === '') {
        this.errors.postal_code = 'Postal code is required';
        valid = false;
      }
      if (this.province_id === '') {
        this.errors.province_id = 'Province is required';
        valid = false;
      }
      if (!this.cv) {
        this.errors.cv = 'CV is required';
        valid = false;
      }

      return valid;
    },
    resetFileUpload() {
      // Reset the file upload fields
      this.cv = null;
      this.local_file_url = null;
      this.fileType = '';
      this.file_name = '';
      this.isLocalFile = false;
      this.showPreview = false;
      this.errorMessage = '';  // Reset error message
    },

    fetch_question_section() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_sections/`,
        method: "POST",
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : { "Content-Type": "application/json" },
        success: (response) => {
          this.sections = response.data.sections;
        },
        complete: () => {
          this.isLoading = false;
        },
      });

    },
    fetch_type_of_organization() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_type_of_organization/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.type_of_organization = response.data.type_of_organization_data;
          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
    fetch_type_of_profile() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_type_of_profile/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.type_of_profile = response.data.type_of_profile_data;

          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },


    fetchProfiles() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_profiles/`,
        type: 'POST',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success' && response.data.profiles) {
            this.base_profiles = response.data.profiles;
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },



    clearPersonalData() {
      this.email = '';
      this.phone_number = '';
    },

    getActiveProfile() {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_active_profile/`,
        type: "GET",
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        success: (response) => {
          if (response.status === "success") {
            this.currentProfile = true;

            const profileTypeName = response.data.profile_type?.toLowerCase();

            if (profileTypeName === 'business' && response.data) {
              this.isBusinessProfile = true;
              this.isPersonalProfile = false;
              this.profileLoaded = true;

            } else {
              this.isBusinessProfile = false;
              this.isPersonalProfile = true;
              this.profileLoaded = true;

            }
          }
        },
        error: (xhr, status, error) => {
          console.error("Error fetching active profile:", error);
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },

    show_questions() {

      const businessProfile = this.type_of_profile.find(
        (profile) => profile.name.toLowerCase() === 'business'
      );
      const payload = {
        filter_values: {
          profile_type_id: businessProfile.id,
        },
      };
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/filter_assigned_profile_questions/`,
        type: "POST",
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(payload),
        success: (response) => {
          this.profile_questions = response.data;
        },
      });
    }
  },
};
